import { useAiGenerateTool } from './AiGenerateButton';
import { ChoiceRandomShuffleButton } from './ChoiceRandomShuffleButton';
import { Divider } from './Divider';
import { EditToolsDrawer } from './EditToolsDrawer';
import { ImageAddButton } from './ImageAddButton';
import { InlineTooltipContainer } from './InlineTooltipContainer';
import { QuizDeleteButton } from './QuizDeleteButton';
import { QuizDuplicateButton } from './QuizDuplicateButton';

export const EditTools = {
  InlineTooltipContainer,
  Divider,
  QuizDuplicateButton,
  QuizDeleteButton,
  ImageAddButton,
  EditToolsDrawer,
  ChoiceRandomShuffleButton,
  useAiGenerateTool,
};
